import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Paper, ColorBatch } from 'components';
import { dateTimeFormat, actionTypeName, actionTypeColorMap } from 'enums';
import { jsx as ___EmotionJSX } from "@emotion/react";

var tableContainer = function tableContainer(theme) {
  return {
    border: "1px solid ".concat(theme.gray100)
  };
};

var tableHead = function tableHead(theme) {
  return {
    display: 'flex',
    padding: '0 1.5em',
    backgroundColor: theme.gray50
  };
};

var tableRow = function tableRow(theme) {
  return {
    display: 'flex',
    padding: '0 1.5em',
    borderBottom: "1px solid ".concat(theme.gray100),
    transition: 'background-color .2s ease',
    '&:last-of-type': {
      borderBottom: 'none'
    },
    '&:hover': {
      backgroundColor: theme.gray50
    }
  };
};

var cellStyle = function cellStyle() {
  var flex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1 1 100px';
  return {
    flex: flex,
    padding: '1.2em 0.7em',
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.3rem'
  };
};

var headCellStyle = function headCellStyle() {
  var flex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1 1 100px';
  return function (theme) {
    return {
      flex: flex,
      padding: '1em 0.7em',
      color: theme.gray300,
      fontSize: '1.2rem',
      fontWeight: 600
    };
  };
};

var emptyStyle = function emptyStyle(theme) {
  return {
    padding: '2em',
    textAlign: 'center',
    color: theme.gray400
  };
};

var CreditHistoryTab = function CreditHistoryTab(_ref) {
  var history = _ref.history;
  return ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref2) {
      var css = _ref2.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0418\u0441\u0442\u043E\u0440\u0438\u044F"));
    },
    margin: "0 0 2em 0"
  }, ___EmotionJSX("div", {
    css: tableContainer
  }, ___EmotionJSX("div", {
    css: tableHead
  }, ___EmotionJSX("div", {
    css: headCellStyle('0 0 160px')
  }, "\u0414\u0430\u0442\u0430"), ___EmotionJSX("div", {
    css: headCellStyle('0 0 160px')
  }, "\u0421\u043B\u0443\u0436\u0438\u0442\u0435\u043B"), ___EmotionJSX("div", {
    css: headCellStyle('1 1 200px')
  }, "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435"), ___EmotionJSX("div", {
    css: headCellStyle('0 0 180px')
  }, "\u0422\u0438\u043F \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435")), (history === null || history === void 0 ? void 0 : history.length) > 0 ? history.map(function (el) {
    var _el$user;

    return ___EmotionJSX("div", {
      css: tableRow,
      key: el === null || el === void 0 ? void 0 : el.id
    }, ___EmotionJSX("div", {
      css: cellStyle('0 0 160px')
    }, moment(el === null || el === void 0 ? void 0 : el.created_at).isValid() ? moment(el === null || el === void 0 ? void 0 : el.created_at).format(dateTimeFormat) : 'N/A'), ___EmotionJSX("div", {
      css: cellStyle('0 0 160px')
    }, el === null || el === void 0 ? void 0 : (_el$user = el.user) === null || _el$user === void 0 ? void 0 : _el$user.name), ___EmotionJSX("div", {
      css: cellStyle('1 1 200px')
    }, el === null || el === void 0 ? void 0 : el.data), ___EmotionJSX("div", {
      css: cellStyle('0 0 180px')
    }, ___EmotionJSX(ColorBatch, {
      type: actionTypeColorMap[el === null || el === void 0 ? void 0 : el.action],
      fontSize: "1rem"
    }, actionTypeName[el === null || el === void 0 ? void 0 : el.action])));
  }) : ___EmotionJSX("div", {
    css: emptyStyle
  }, "\u041D\u044F\u043C\u0430 \u0437\u0430\u043F\u0438\u0441\u0430\u043D\u0438 \u0441\u044A\u0431\u0438\u0442\u0438\u044F.")))));
};

CreditHistoryTab.propTypes = {
  history: PropTypes.array
};
export default CreditHistoryTab;